// Inline copy of `logos_report/nws_logo_sidebar.svg` so we can recolour it
// via `currentColor` (sidebar uses text-primary; dark mode flips the hue
// without needing a second asset).
export function NwsLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      className={className}
      role="img"
      aria-label="nws"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.041,20.579c4.282,1.128,6.951.119,9.731-3.862-0.664-.874-1.38-1.759-2.032-2.69s-1.244-1.915-2.019-3.119A25.876,25.876,0,0,1,24.1,13.62c-1.739,4.765-4.363,8.726-8.517,11.489a4.965,4.965,0,0,1-5.227.216,9.413,9.413,0,0,1-2.178-1.453C7.077,22.838,6.082,21.683,5.041,20.579ZM9.048,1.036C6.24,3.823,5.79,6.77,7.342,10.476a29.744,29.744,0,0,0,2.164,4.185c0.827,1.331,1.843,2.542,2.78,3.812C9.97,21.186,5,20.629,3.1,17.346A22.7,22.7,0,0,1,.262,8.865,5.33,5.33,0,0,1,3.282,2.935a51.062,51.062,0,0,1,5.766-1.9h0ZM24.862,10.9A26.785,26.785,0,0,0,7.548,8.3,5.868,5.868,0,0,1,13.094.851,22.965,22.965,0,0,1,21.125,2.33,6.455,6.455,0,0,1,24.862,10.9Z"
      />
    </svg>
  );
}
